import React, { useEffect, useState } from 'react';
import { handleGetApiExplorerDocumentation } from '@app/store/actions';
import { useSelector, useDispatch } from 'react-redux';
import { mainMenuTypes, IMenuItem } from '@app/components/Sidebar/menuObject';
import { getMenuItemById } from '@app/helpers';
import { apiExplorerService } from '@app/services';
import { useTypedTranslation, useSetPage } from '@app/hooks';
import { ApiPropertyList, ApiMethodList, ApiEnumList } from './components';
import { TranslationNamespace } from '@app/models';

const ApiExplorerPage = () => {
    const { translation } = useTypedTranslation(TranslationNamespace.apiDescription);
    const item: IMenuItem | undefined = getMenuItemById(mainMenuTypes.ApiExplorer);

    const [menuItem] = useState<IMenuItem | undefined>(item);
    const [schema, setSchema] = useState<any[]>([]);

    const apiDocumentation = useSelector((state: any) => state.apiExplorer.apiDocumentation);

    const dispatch = useDispatch();

    useSetPage(null, menuItem);
    useEffect(() => {
        dispatch(handleGetApiExplorerDocumentation());
    }, []);

    useEffect(() => {
        if (apiDocumentation !== undefined && apiDocumentation !== null) {
            setSchema(apiExplorerService.convertSchema(apiDocumentation));
        }
    }, [apiDocumentation]);

    const entityDescription = (item: any) => {
        const split = item.name.split('.');
        let name = split[split.length - 1];
        name = 'API_' + name + '_DESCRIPTION';
        name = name.toUpperCase();
        const translatedName = translation(name);
        if (translatedName === name) return item.name;
        return translatedName;
    };

    const parseName = (key: any) => {
        const last = key.lastIndexOf('.');
        return key.substring(last + 1);
    };

    const parseNamespace = (name: any) => {
        const last = name.lastIndexOf('.');
        return name.substring(0, last);
    };

    return (
        <div className='apiExplorer'>
            {schema.map((item: any, index: number) => (
                <section key={index} className='apiExplorer__section'>
                    <h2 id={item.key} key={item.key}>
                        {parseName(item.key)}
                    </h2>

                    <div className='type-list'>
                        <dl>
                            <dt>{translation('MEMBER_NAMESPACE')}</dt>
                            <dd>{parseNamespace(item.key)}</dd>
                            <dt hidden={!item.baseType}>{translation('MEMBER_BASETYPE')}</dt>
                            <dd hidden={!item.baseType}><a href='#'>{item.baseType}</a></dd>
                            <dt>{translation('MEMBER_ABSTRACT')}</dt>
                            <dd>{item.abstract}</dd>
                            <dt>{translation('MEMBER_TYPE')}</dt>
                            <dd>{item.type}</dd>
                        </dl>

                        <div>
                            <h3>{translation('MEMBER_DESCRIPTION')}</h3>
                            <p>{entityDescription(item)}</p>
                        </div>

                        <div hidden={!item.path}>
                            <h3>Collection Path <code>{item.path}</code></h3>

                            <div className='collection-delegates'>
                                {item.functions && item.functions.collection &&
                                    <div className='apiExplorer__list'>
                                        <h5 className='apiExplorer__list-header'>Functions</h5>
                                        <ApiMethodList entity={item.name} methods={item.functions.collection} />
                                    </div>
                                }

                                {item.actions && item.actions.collection &&
                                    <div className='apiExplorer__list'>
                                        <h5 className='apiExplorer__list-header'>Actions</h5>
                                        <ApiMethodList entity={item.name} methods={item.actions.collection} />
                                    </div>
                                }
                            </div>
                        </div>

                        <div hidden={!item.entityPath}>
                            <h3>Entity Path <code>{item.entityPath}</code></h3>
                            {item.functions && item.functions.entity &&
                                <div className='apiExplorer__list'>
                                    <h5 className='apiExplorer__list-header'>Functions</h5>
                                    <ApiMethodList entity={item.name} methods={item.functions.entity} />
                                </div>
                            }

                            {item.actions && item.actions.entity &&
                                <div className='apiExplorer__list'>
                                    <h5 className='apiExplorer__list-header'>Actions</h5>
                                    <ApiMethodList entity={item.name} methods={item.actions.entity} />
                                </div>
                            }
                        </div>

                        <ApiPropertyList entity={item} schema={schema} />

                        {item.members &&
                            <ApiEnumList enumValue={item} />
                        }

                    </div>
                </section>
            ))
            }
        </div>
    );
};

export default ApiExplorerPage;
